"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var swr_hooks_1 = require("@l2p/swr-hooks");
var apps_shared_1 = require("@l2p/apps-shared");
var Currencies = function (_a) {
    var _b;
    var isNarrowXl = _a.isNarrowXl;
    var _c = (0, swr_hooks_1.useBalance)(), data = _c.data, isLoading = _c.isLoading;
    if (!data && isLoading)
        return null;
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.currencyInfoWrapper, " ").concat(!isNarrowXl ? styles_module_scss_1.default.big : '') },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.currencyInfo }, "".concat((0, apps_shared_1.getCurrencySymbol)(data === null || data === void 0 ? void 0 : data.currency), " ").concat((_b = Number(data === null || data === void 0 ? void 0 : data.totalAmount)) === null || _b === void 0 ? void 0 : _b.toFixed(2)))));
};
exports.default = Currencies;
